import { makeReducer } from '../utils/redux.tools';
import { SinglePageActions } from '../actions/singlePage.actions';

import arrayMove from 'array-move';

export const initialState = {
    page: {}
};

const singlePageRed = {
    [SinglePageActions.FETCH_SINGLE_PAGE_RETURN]: (state, payload) => ({
        ...state,
        page: payload
    }),

    [SinglePageActions.UPDATING_PAGE_SETTINGS]: state => ({
        ...state,
        updatedPagePath: undefined,
        pageSettingsUpdating: true,
        pageSettingsUpdateSuccess: false,
        pageSettingsUpdateFailed: false
    }),
    [SinglePageActions.UPDATE_PAGE_SETTINGS_SUCCESS]: (state, payload) => ({
        ...state,
        updatedPagePath: payload,
        pageSettingsUpdating: false,
        pageSettingsUpdateSuccess: true,
        pageSettingsUpdateFailed: false
    }),
    [SinglePageActions.UPDATE_PAGE_SETTINGS_FAILED]: (state, payload) => ({
        ...state,
        updatedPagePath: payload,
        pageSettingsUpdating: false,
        pageSettingsUpdateSuccess: false,
        pageSettingsUpdateFailed: true
    }),
    [SinglePageActions.CLEAR_UPDATE_PAGE_SETTINGS]: state => ({
        ...state,
        updatedPagePath: undefined,
        pageSettingsUpdating: false,
        pageSettingsUpdateSuccess: false,
        pageSettingsUpdateFailed: false
    }),

    [SinglePageActions.CLEAR_SINGLE_PAGE]: state => ({ ...state, page: {} }),

    [SinglePageActions.CLEAR_SAVE_PAGE_CONTENTS]: state => ({ ...state, savePageContentsSuccess: undefined }),
    [SinglePageActions.SAVE_PAGE_CONTENTS_DONE]: (state, payload) => ({ ...state, savePageContentsSuccess: payload }),

    [SinglePageActions.ADD_COMPONENT_TO_PAGE]: (state, payload) => {
        let compObj = {
            type: payload.component,
            props: {}
        };
        state.page.templateConf[payload.fieldName].push(compObj);
        return { ...state };
    },
    [SinglePageActions.UPDATE_COMPONENT_OF_PAGE]: (state, payload) => {
        state.page.templateConf[payload.fieldName][payload.index].props = payload.newProps;
        return { ...state };
    },
    [SinglePageActions.CLEAR_COMPONENTS_OF_FIELD]: (state, payload) => {
        state.page.templateConf[payload] = [];
        return { ...state };
    },
    [SinglePageActions.REMOVE_SINGLE_COMPONENT_OF_FIELD]: (state, payload) => {
        state.page.templateConf[payload.fieldName].splice(payload.index, 1);
        return { ...state };
    },
    [SinglePageActions.SWAP_COMPONENTS_OF_FIELD]: (state, payload) => {
        state.page.templateConf[payload.fieldName] = arrayMove(state.page.templateConf[payload.fieldName], payload.index, payload.newIndex);
        return { ...state };
    }
};

export const singlePageReducer = makeReducer('SinglePage', initialState, singlePageRed);
